export default __webpack_public_path__ + "static/media/certicicationicon.c3682308.svg";